// src/registerServiceWorker.js
import { Workbox } from "workbox-window";

let hasReloaded = false;

export function register() {
  if ("serviceWorker" in navigator) {
    if (process.env.NODE_ENV === 'development') {
      // fix for infinite reloads in craco start
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
          registration.unregister();
        }
      });
    }
    
    window.addEventListener("load", () => {
      const wb = new Workbox("/sw.js", {
        updateViaCache: "none",
      });

      if (process.env.NODE_ENV !== "development") {
        // ✅ Auto-reload only in production
        wb.addEventListener("controlling", () => {
          if (!hasReloaded) {
            hasReloaded = true;
            console.log("✅ New SW controlling → reloading page");
            window.location.reload();
          }
        });
      } else {
        console.log("⚡ SW registered in development (no auto reload, caching still works)");
      }

      wb.register()
        .then(() => {
          console.log("📦 Service Worker registered:", process.env.NODE_ENV);
        })
        .catch((error) => {
          console.error("❌ Service Worker registration failed:", error);
        });
    });
  } else {
    console.warn("Service workers are not supported in this browser.");
  }
}
